"use strict";

function config($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise("/home");

    /*
     Sets up a state resolver which is attached to every state
     */
    const routeStateResolver = {
        authenticateUser: ['PermissionService', '$stateParams', function (PermissionService, $stateParams) {
            return PermissionService.verifyUserPermissionsForState($stateParams);
        }]
    };

    $stateProvider
        .state('app', {
            abstract: true,
            template: '<ui-view/>',
            params: { brandId: null, callCenterId: null, storeId: null }
        })
        .state('app.home', {
            url: "/home",
            title: 'Home',
            views: {

                // Main view template
                '': {
                    template: '<home></home>'
                }
            },
            resolve: routeStateResolver
        })
        .state('signin', {
            url: "/signin/?returnUrl",
            title: 'Sign in',
            templateUrl: "views/signin.d41d8cd9.html",
            controller: 'SignInController',
            params : { returnUrl: null }
        })
        .state('accessdenied', {
            url: "/accessdenied",
            title: 'Access Denied',
            templateUrl: "views/accessdenied.8366ceb2.html",
            controller: 'AccessDeniedController'
        });

    function addToStateProviderCallback(item) {
        if (item.stateConfig) {
            $stateProvider.state(item.stateConfig.state, {
                title: item.title || item.menuVal,
                url: item.stateConfig.url,
                params: item.stateConfig.params,
                views: item.stateConfig.views,
                resolve: _.extend(routeStateResolver, item.stateConfig.resolve)
            });
        }
        if (item.subMenuItems) {
            _.each(item.subMenuItems, function (subItem) {
                if (subItem.stateConfig) {
                    $stateProvider.state(subItem.stateConfig.state, {
                        title: `${item.menuVal} - ${subItem.subMenuVal}`,
                        url: subItem.stateConfig.url,
                        params: subItem.stateConfig.params,
                        views: subItem.stateConfig.views,
                        resolve: _.extend(routeStateResolver, subItem.stateConfig.resolve)
                    });
                }
            })
        }
    }

    _.each(Dashboard.menuStates.groups, function (group) {
        _.each(group.brandItems, addToStateProviderCallback);
        _.each(group.callCenterItems, addToStateProviderCallback);
        _.each(group.storeItems, addToStateProviderCallback);
    });
}

run.$inject = ['$rootScope', '$state', '$transitions'];

function run($rootScope, $state, $transitions) {
    $rootScope.$state = $state;
    $transitions.onBefore({}, function(transition) {
        const toState = transition.to();
        const fromState = transition.from();
        if (toState.name === fromState.name) {
            // Cancel the transition if the destination state is the same as the current state.
            // This can cause undesired affects of components loading twice.
            return false;
        }
        window.scrollTo({ left: 0, top: 0});
    });
}

config.$inject = ['$stateProvider', '$urlRouterProvider'];

angular
    .module('dashboard')
    .config(config)
    .run(run);
